import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { fromJS } from "immutable"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { selectCustomFields } from "shared/customFields/selectors"
import { loadCustomFields } from "shared/customFields/action-creators"

import { parseAndGenerateCustomFilters } from "shared/search/components/FilterableListView/helperFunctions"
import { getCustomQuestionField } from "shared/search/containers/Filter/Filters"

export const createCustomQuestionFilterGroup = (customDataType) => {
    const mapStateToProps = (state, props) => ({
        customTags: selectCustomFields(customDataType)(state),
    })
    const actions = {
        loadCustomFields,
    }

    class UnconnectedCustomFilterGroup extends Component {
        shouldComponentUpdate(nextProps) {
            return (
                !fromJS(nextProps.customTags).equals(fromJS(this.props.customTags)) ||
                nextProps.searchFilterTerm !== this.props.searchFilterTerm
            )
        }

        render() {
            const customQuestionFilters = [getCustomQuestionField(this.props.customTags)]
            const customAnswersFilters = parseAndGenerateCustomFilters(this.props.customTags, this.props.customDataType)

            return (
                <>
                    {genericFilterGroup({
                        ...this.props,
                        uniqueFilterGroupId: "gaCustomQuestionFilterGroup",
                        filters: customQuestionFilters,
                        displayLabel: "Custom Questions",
                        helpText: "Filter results by a custom question.",
                    })}

                    {genericFilterGroup({
                        ...this.props,
                        uniqueFilterGroupId: "gaCustomAnswerFilterGroup",
                        filters: customAnswersFilters,
                        displayLabel: "Custom Answers",
                        helpText: "Filter results by a custom answers.",
                    })}
                </>
            )
        }
    }

    UnconnectedCustomFilterGroup.propTypes = {
        additionalFilters: PropTypes.array,
        customDataType: PropTypes.number.isRequired,
        customTags: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        loadCustomFields: PropTypes.func.isRequired,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
    }

    const connectedFilterGroup = connect(mapStateToProps, actions)(UnconnectedCustomFilterGroup)
    Object.assign(connectedFilterGroup, {
        defaultProps: {
            customDataType,
            uniqueFilterGroupId: "gaInteractiveFilterGroup", // setting this just to pass on tests
        },
    })

    return connectedFilterGroup
}
